<span class="p-input-icon-right width100">
    <input class="width100 searchInput" [ngModel]="value" (ngModelChange)="updateValue($event)" type="text" pInputText
        placeholder="Jump to" />
</span>